var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.maskRects),function(rect,i){return _c('rectangle',{key:i,attrs:{"parent-container":_vm.screenContainer,"bounds":rect,"render-tools":_vm.renderTools,"alpha":0.9,"fill-color":0x000000,"line-width":0}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }